import React from 'react';
import { Folder, FileText, ImageSquare } from '@phosphor-icons/react';

const FileExplorerEntryIcon = ({ entry, size = 18 }) => {
  // Carpeta e imagen pierden la distinción de color a propósito (RNF-004,
  // B3 = A): ambas pasan a text-content-muted. La distinción se conserva
  // por forma de icono — Folder vs. ImageSquare/FileText ya son glifos
  // distintos, no hace falta cambiar el componente de icono.
  if (entry.type === 'folder') {
    return <Folder size={size} className="text-content-muted" />;
  }

  if (entry.fileType === 'imagen') {
    return <ImageSquare size={size} className="text-content-muted" />;
  }

  return <FileText size={size} className="text-content-muted" />;
};

export default FileExplorerEntryIcon;
